(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Só executa se houver hash na URL E se for um card de produto (não uma seção de página normal)
  const url = new URL(window.location.href);
  if (url.hash) {
    const hashId = url.hash.slice(1);
    
    // Função para lidar com o scroll do hash
    const handleHashScroll = () => {
      const card = document.getElementById(hashId);
      if (!card) return;

      // Só executa se for um card de produto (product-card-link ou dentro de product-grid)
      // Não interfere com navegação normal de hash em outras páginas
      const isProductCard = card.closest('product-card-link, .product-grid, .product-grid__item, product-card');
      if (!isProductCard) {
        // Permite que o navegador faça o scroll normalmente
        return;
      }

      // Usa requestAnimationFrame para evitar flicker
      requestAnimationFrame(() => {
        // Verifica se o elemento já está visível antes de fazer scroll
        const rect = card.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.top < window.innerHeight;
        
        if (!isVisible) {
          card.scrollIntoView({ behavior: 'instant', block: 'nearest' });
        }
        
        // Remove o foco apenas no Safari para evitar borda preta
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
          requestAnimationFrame(() => {
            if (document.activeElement && card.contains(document.activeElement)) {
              document.activeElement.blur();
            }
            const focusedElement = card.querySelector(':focus');
            if (focusedElement) {
              focusedElement.blur();
            }
          });
        }
      });
    };

    // Aguarda o evento pagereveal se disponível (View Transitions API)
    // Isso garante que as view transitions terminem antes de fazer scroll
    if ('pagereveal' in window) {
      window.addEventListener('pagereveal', (event) => {
        // Aguarda a view transition terminar completamente
        if (event.viewTransition) {
          event.viewTransition.finished.then(() => {
            // Aguarda alguns frames adicionais para garantir que tudo está renderizado
            // E para evitar conflito com restauração de scroll do view-transitions.js
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  handleHashScroll();
                });
              });
            });
          });
        } else {
          // Se não houver view transition, aguarda um pouco para evitar conflito
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                handleHashScroll();
              });
            });
          });
        }
      }, { once: true });
    } else {
      // Fallback para navegadores sem View Transitions API
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          // Aguarda alguns frames para garantir que tudo está renderizado
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              handleHashScroll();
            });
          });
        }, { once: true });
      } else {
        // Aguarda alguns frames para garantir que as animações terminaram
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            handleHashScroll();
          });
        });
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  // Só executa se houver hash na URL E se for um card de produto (não uma seção de página normal)
  const url = new URL(window.location.href);
  if (url.hash) {
    const hashId = url.hash.slice(1);
    
    // Função para lidar com o scroll do hash
    const handleHashScroll = () => {
      const card = document.getElementById(hashId);
      if (!card) return;

      // Só executa se for um card de produto (product-card-link ou dentro de product-grid/resource-list)
      // Não interfere com navegação normal de hash em outras páginas
      const isProductCard = card.closest('product-card-link, .product-grid, .product-grid__item, product-card, .resource-list, .resource-list__item');
      if (!isProductCard) {
        // Permite que o navegador faça o scroll normalmente
        return;
      }

      // Usa requestAnimationFrame para evitar flicker
      requestAnimationFrame(() => {
        // Verifica se o elemento já está visível antes de fazer scroll
        const rect = card.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.top < window.innerHeight;
        
        if (!isVisible) {
          card.scrollIntoView({ behavior: 'instant', block: 'nearest' });
        }
        
        // Remove o foco apenas no Safari para evitar borda preta
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
          requestAnimationFrame(() => {
            if (document.activeElement && card.contains(document.activeElement)) {
              document.activeElement.blur();
            }
            const focusedElement = card.querySelector(':focus');
            if (focusedElement) {
              focusedElement.blur();
            }
          });
        }
      });
    };

    // Aguarda o evento pagereveal se disponível (View Transitions API)
    // Isso garante que as view transitions terminem antes de fazer scroll
    if ('pagereveal' in window) {
      window.addEventListener('pagereveal', (event) => {
        // Aguarda a view transition terminar completamente
        if (event.viewTransition) {
          event.viewTransition.finished.then(() => {
            // Aguarda alguns frames adicionais para garantir que tudo está renderizado
            // E para evitar conflito com restauração de scroll do view-transitions.js
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  handleHashScroll();
                });
              });
            });
          });
        } else {
          // Se não houver view transition, aguarda um pouco para evitar conflito
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                handleHashScroll();
              });
            });
          });
        }
      }, { once: true });
    } else {
      // Fallback para navegadores sem View Transitions API
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          // Aguarda alguns frames para garantir que tudo está renderizado
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              handleHashScroll();
            });
          });
        }, { once: true });
      } else {
        // Aguarda alguns frames para garantir que as animações terminaram
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            handleHashScroll();
          });
        });
      }
    }
  }

  } catch(e) { console.error(e); }
})();
})();
